import { FunctionComponent } from 'react';
import CTAButton from '~/components/shared/CTAButton';
import {
  footerClasses,
  footerLinkClasses,
  footerLinksClasses,
  footerBottomClasses,
  dividerClasses,
  copyrightClasses,
} from './footerClasses';

const FOOTER_LINKS: { href: string; name: string }[] = [
  {
    href: 'https://www.walmart.com/help/article/walmart-com-terms-of-use/3b75080af40340d6bbd596f116fae5a0',
    name: 'Terms of Use',
  },
  {
    href: 'https://corporate.walmart.com/privacy-security',
    name: 'Privacy & Security',
  },
  {
    href: 'https://corporate.walmart.com/privacy-security/california-privacy-rights',
    name: 'CA Privacy Rights',
  },
  {
    href: 'https://www.walmart.com/account/api/ccpa-intake?native=false&app=gm&type=sod',
    name: 'Do Not Sell My Personal Information',
  },
  {
    href: 'https://www.walmart.com/account/api/ccpa-intake?native=false&app=gm&type=access',
    name: 'Request My Personal Information',
  },
];

const Footer: FunctionComponent = () => (
  <footer className={footerClasses}>
    <ul className={footerLinksClasses}>
      {FOOTER_LINKS.map(({ href, name }) => (
        <li key={`${href}-${name}`} className={footerLinkClasses}>
          <CTAButton
            variant='text-link'
            size='thin'
            href={href}
            elementPosition='FOOTER'
          >
            {name}
          </CTAButton>
        </li>
      ))}
    </ul>
    <div className={footerBottomClasses}>
      <hr className={dividerClasses} />
      <span className={copyrightClasses}>
        © {new Date().getFullYear()} Walmart. All Rights Reserved
      </span>
    </div>
  </footer>
);

export default Footer;
